import { Office_location_coordinates } from '../__generated__/graphql';

export const getMapLink = (coordinates: Office_location_coordinates) => {
  return `https://www.google.com/maps/search/?api=1&query=${coordinates.lat},${coordinates.lng}`;
};
